export default __webpack_public_path__ + "static/pursue-abd70ba3b465029934fb735e58832033.png";